import React from 'react';

import { Box, Typography } from '@mui/joy';

export interface FlightTimeEstimateProps {
  estTimeToHome: string;
  estTimeUntilLowBattery: string;
}

const FlightTimeEstimate: React.FC<FlightTimeEstimateProps> = ({ estTimeToHome, estTimeUntilLowBattery }) => (
  <Box className='text-right space-y-1'>
    <Typography level='body-xs'>To Home: {estTimeToHome}</Typography>
    <Typography level='body-xs'>Until 10% Batt: {estTimeUntilLowBattery}</Typography>
  </Box>
);

export default FlightTimeEstimate;
